<template>
  <div class="widget-card widget-sales">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text g__card-title justify-center">
        Анкеты
      </v-card-title>
      <v-card-actions class="pa-3 widget-card__card-actions widget-sales__actions mb-2" bottom>
        <v-tooltip top right v-if="!isObjectAllow">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="#757575"
              v-bind="attrs"
              v-on="on"
              class="mr-2 mt-3"
              size="18"
            >mdi-help-circle-outline
            </v-icon>
          </template>
          Для создания объекта ваша компания-партнер должна быть подтверждена администратором
        </v-tooltip>

        <div class="buttons-block pt-4">
          <v-btn
            v-if="true"
            block
            color="primary"
            to="/add-object/null"
            :disabled="!isObjectAllow"
          >
            <span>Данные объекта</span>
            <font-awesome-icon icon="chevron-right" class="mr-2 size-18 btn-icon"/>
          </v-btn>
          <!--v-banner  v-if="isDealer && !isPeriodOpen"> <span class="pl-4">Период закрыт</span></v-banner-->
          <v-btn
            block
            color="primary"
            to="/objects"
          >
            <span>Мои объекты</span>
            <font-awesome-icon icon="chevron-right" class="mr-2 size-18 btn-icon"/>
          </v-btn>
        </div>

      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    props: ['user'],
    computed: {
      isSaleAllow() {
        // eslint-disable-next-line
        return !!(this.$store.state.user.dealer && (this.$store.state.user.dealer.active === 1) && (this.$store.state.sales.activeObjectsList) && (this.$store.state.sales.activeObjectsList.length > 0));
      },
      isObjectAllow() {
        return !!(this.$store.state.user.dealer && (this.$store.state.user.dealer.active === 1));
      },
    },
    methods: {
      CloseSales() {
        this.$store.dispatch('ShowError', 'Уважаемые участники, внесение продаж приостановлено, в связи с окончанием программы лояльности "Клуб Профессионалов"');
      },
    },
  };
</script>

<style lang="scss">
  .widget-card__card {
    display: flex!important;
    flex-direction: column;
    justify-content: space-between;
  }

  .widget-sales {
    height: 100%;

    &__actions {
      flex-direction: column;
    }

    .buttons-block {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      &__title {
        color: rgba(0, 0, 0, .6);
        font-weight: bold;
      }
    }
  }
</style>
